import { QBR_TRANSLATIONS_NAMESPACE } from '../../../../../translations'

const INITIATIVES_TRANSLATIONS_NAMESPACE = `${QBR_TRANSLATIONS_NAMESPACE}--initiatives`

export const TRANSLATION_KEYS = {
  initiativeCard: {
    offering: `${INITIATIVES_TRANSLATIONS_NAMESPACE}--card--offering-label`,
    keyObjective: `${INITIATIVES_TRANSLATIONS_NAMESPACE}--card--key-objective-label`,
    businessUnit: `${INITIATIVES_TRANSLATIONS_NAMESPACE}--card--business-unit`,
    byOwner: `${INITIATIVES_TRANSLATIONS_NAMESPACE}--card--by-owner`,
    goal: `${INITIATIVES_TRANSLATIONS_NAMESPACE}--card--goal`,
    noFundsNeeded: `${INITIATIVES_TRANSLATIONS_NAMESPACE}--card--no-funds-needed`,
    fundsNeeded: `${INITIATIVES_TRANSLATIONS_NAMESPACE}--card--funds-needed`,
    from: `${INITIATIVES_TRANSLATIONS_NAMESPACE}--card--from`,
    currentProgressPlaceholder: `${INITIATIVES_TRANSLATIONS_NAMESPACE}--card--current-progress-placeholder`,
    followUp: `${INITIATIVES_TRANSLATIONS_NAMESPACE}--card--follow-up-placeholder`,
    removeFromQbrButton: `${INITIATIVES_TRANSLATIONS_NAMESPACE}--card--remove-from-qbr`,
    initiativesLink: `${INITIATIVES_TRANSLATIONS_NAMESPACE}--card--initiatives-link`,
  },

  availableInitiativesColumns: {
    name: `${INITIATIVES_TRANSLATIONS_NAMESPACE}--column--name-label`,
    description: `${INITIATIVES_TRANSLATIONS_NAMESPACE}--column--description-label`,
    businessUnit: `${INITIATIVES_TRANSLATIONS_NAMESPACE}--column--business-unit-label`,
    financialGoal: `${INITIATIVES_TRANSLATIONS_NAMESPACE}--column--financial-goal-label`,
    incremental: `${INITIATIVES_TRANSLATIONS_NAMESPACE}--column--incremental-label`,
    period: `${INITIATIVES_TRANSLATIONS_NAMESPACE}--column--period-label`,
    fundsNeeded: `${INITIATIVES_TRANSLATIONS_NAMESPACE}--column--funds-needed-label`,
    owner: `${INITIATIVES_TRANSLATIONS_NAMESPACE}--column--owner-label`,
    status: `${INITIATIVES_TRANSLATIONS_NAMESPACE}--column--status-label`,
  },

  initiativesDialog: {
    dialogLabel: `${INITIATIVES_TRANSLATIONS_NAMESPACE}--initiatives-dialog--dialog-label`,
    addInitiativesButton: `${INITIATIVES_TRANSLATIONS_NAMESPACE}--initiatives-dialog--add-initiatives-button-label`,
  },

  deleteInitiativeDialog: {
    dialogText: `${INITIATIVES_TRANSLATIONS_NAMESPACE}--delete-initiative-dialog--dialog-text`,
    submitButton: `${INITIATIVES_TRANSLATIONS_NAMESPACE}--delete-initiative-dialog--submit-button-label`,
  },

  addInitiativeButton: `${INITIATIVES_TRANSLATIONS_NAMESPACE}--add-initiatives-button-label`,
}
